import defaultAxios from "axios";
import { toast } from "react-toastify";

const axios = defaultAxios.create({
  // baseURL: "http://node.bplugins.com:5000",
  baseURL: window.origin.includes("localhost") ? "http://localhost:5000" : "https://bplugins-dashboard.vercel.app",
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add an interceptor to include the authentication token in requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token"); // Replace with your token storage mechanism
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    toast.error(error.message);
    return Promise.reject(error);
  }
);

export default axios;
